import { useContext } from "react";

export function isLoggedIn() {
  const auth = localStorage.getItem('auth');
  const user = localStorage.getItem('user');
  const token = localStorage.getItem('token');

  return auth && user && token;
}